export default __webpack_public_path__ + "static/media/close-black.fca83fdd.svg";